export default __webpack_public_path__ + "static/media/qr-code-yellow.173d27a9.svg";